import {
    TeamOutlined,
    SafetyCertificateOutlined,
    CreditCardOutlined,
    ClusterOutlined
} from '@ant-design/icons-vue';
import MembersList from '@/views/members/MemberList.vue';
import MemberDetail from '@/views/members/MemberDetail.vue';
import PaymentApi from '@/views/settings/PaymentApi.vue';
import { MEMBER_LIST_PROFILE } from '@/views/members/memberListProfiles.js';
import { platformOpsLeafRoutes } from './platform.js';

/** 系統營運（選單置底；含原平台管理葉頁） */
export const membersMgmtFolderRoute = {
    path: 'member-mgmt',
    name: 'MemberMgmt',
    redirect: '/members',
    meta: {
        title: '系統營運',
        icon: SafetyCertificateOutlined
    },
    children: []
};

/** 管理者視角會員列表（掛在系統營運下） */
export const membersListRoute = {
    path: '/members',
    component: MembersList,
    name: 'MembersList',
    meta: {
        title: '會員管理（管理視角）',
        icon: TeamOutlined,
        memberListProfile: MEMBER_LIST_PROFILE.FULL
    }
};

/** 金流串接設定 */
export const paymentApiRoute = {
    path: '/platform/payment-api',
    component: PaymentApi,
    name: 'PaymentApi',
    meta: {
        title: '金流串接設定',
        icon: CreditCardOutlined
    }
};

/** 單層選單：一般行政列表（欄位對齊業務視角，密碼受限） */
export const membersAdminRoute = {
    path: '/members/general',
    component: MembersList,
    name: 'MembersGeneralAdmin',
    meta: {
        title: '用戶管理',
        icon: TeamOutlined,
        memberListProfile: MEMBER_LIST_PROFILE.GENERAL_ADMIN
    }
};

export const memberDetailRoute = {
    path: '/members/:id(\\d+)',
    component: MemberDetail,
    name: 'MemberDetail',
    meta: {
        title: '會員詳情',
        hidden: true
    }
};

const memberEntryAccessRoute = {
    path: '/platform/member-entry-access',
    component: () => import('@/views/members/MemberEntryAccess.vue'),
    name: 'MemberEntryAccess',
    meta: {
        title: '會員入口授權',
        description: '子系統／中樞廳樓層／產業鏈身份；批次設定'
    }
};

const opsCompletionPurchaseGrantRoute = {
    path: '/platform/ops-completion-grants',
    component: () => import('@/views/members/OpsCompletionPurchaseGrant.vue'),
    name: 'OpsCompletionPurchaseGrant',
    meta: {
        title: '完課／限購補發',
        description: '補完課與限購占用；不建立訂單'
    }
};

const coursePathsRoute = {
    path: '/platform/course-paths',
    component: () => import('@/views/forms/CoursePaths.vue'),
    name: 'CoursePaths',
    meta: {
        title: '修業進路',
        description: '循序解鎖會擋住前台報名；身份／能力解鎖後續擴充'
    }
};

const industryChainsRoute = {
    path: '/platform/industry-chains',
    component: () => import('@/views/platform/IndustryChains.vue'),
    name: 'IndustryChains',
    meta: {
        title: '產業鏈主檔',
        icon: ClusterOutlined,
        description: '產業鏈、鏈下身份、星圖呈現'
    }
};

const inventoryTypeWhitelistRoute = {
    path: '/platform/inventory-item-types',
    component: () => import('@/views/platform/InventoryTypeWhitelist.vue'),
    name: 'InventoryItemTypes',
    meta: {
        title: '背包物品類型',
        description: '類型／服務白名單；前台串接完成後再開放'
    }
};

const [adminListRoute, roleListRoute, ...integrationRoutes] =
    platformOpsLeafRoutes;

/** 系統營運：依分類巢狀群組（對齊 iceFire _group-*） */
export const membersMgmtChildrenRoutes = [
    {
        path: '_group-member-entry',
        name: 'SystemOps.Group.MemberEntry',
        redirect: '/members',
        meta: { title: '會員與入口' },
        children: [
            membersListRoute,
            memberEntryAccessRoute,
            opsCompletionPurchaseGrantRoute
        ]
    },
    {
        path: '_group-industry',
        name: 'SystemOps.Group.Industry',
        redirect: '/platform/industry-chains',
        meta: { title: '產業鏈主檔' },
        children: [industryChainsRoute]
    },
    {
        path: '_group-course',
        name: 'SystemOps.Group.Course',
        redirect: '/platform/course-paths',
        meta: { title: '修業與能力' },
        children: [coursePathsRoute]
    },
    {
        path: '_group-accounts',
        name: 'SystemOps.Group.Accounts',
        redirect: '/platform/admin-list',
        meta: { title: '帳號與權限' },
        children: [adminListRoute, roleListRoute].filter(Boolean)
    },
    {
        path: '_group-integrations',
        name: 'SystemOps.Group.Integrations',
        redirect: '/platform/payment-api',
        meta: { title: '串接與設定' },
        children: [
            paymentApiRoute,
            inventoryTypeWhitelistRoute,
            ...integrationRoutes
        ]
    }
];

export const membersTopLevelRoutes = [membersAdminRoute, memberDetailRoute];
